import { sendRequestToServer } from "@src/utility_functions/database_operations/sendRequestToServer";

export const createUserGoogle = async () => {
  const returnObject = sendRequestToServer(
    { payload: "payload" },
    "/server/database_operations/users/createUserGoogle",
  );
  return returnObject;
};
